import Base from './base'

function indexOption(list) {
  let key
  const prices = {}

  for (let i = 0; i < list.length; i++) {
    key = list[i].webDescription.replace(/ /g, '')
    if (key === 'SpecialOPSPackage') {
      key = 'TacticalPackage'
    }
    prices[key] = list[i]
  }
  return prices
}

export default {
  get () {
    return Base
      .get('/optionprice/all')
      .then(res => res.data)
      .then(indexOption)
  }
}
